// extracted by mini-css-extract-plugin
export default {"loading":"VirtualizedList_loading__UZDR+","spin":"VirtualizedList_spin__MoGPe","loading-row":"VirtualizedList_loading-row__VT960"};